module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/d5224cb0a5676092dbb95236e7dc2881.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_voluntary.svg
// module id = NWai
// module chunks = 0